import type { PricingStrategyProfileResponse } from '@/shared/api';
import {
  indexedRows,
  profileValues,
  row,
  type ProfileComparisonSection,
} from './profileComparisonModel';

export function buildDemandSections(
  profiles: PricingStrategyProfileResponse[],
): ProfileComparisonSection[] {
  const values = <T>(pick: (profile: PricingStrategyProfileResponse) => T) =>
    profileValues(profiles, pick);
  return [
    {
      id: 'limits',
      titleKey: 'limits',
      rows: [
        row(
          'occupancy-negative',
          'maximumOccupancyContribution',
          'occupancyNegative',
          'percent',
          values((p) => p.maximumNegativeOccupancyAdjustmentPercent),
        ),
        row(
          'occupancy-positive',
          'maximumOccupancyContribution',
          'occupancyPositive',
          'percent',
          values((p) => p.maximumPositiveOccupancyAdjustmentPercent),
        ),
        row(
          'corridor-minimum',
          'softCorridor',
          'corridorMinimum',
          'percent',
          values((p) => p.softCorridorMinimumPercent),
        ),
        row(
          'corridor-maximum',
          'softCorridor',
          'corridorMaximum',
          'percent',
          values((p) => p.softCorridorMaximumPercent),
        ),
        row(
          'formula',
          'occupancyFormula',
          'formula',
          'text',
          values((p) => p.occupancyFormulaKind),
        ),
        row(
          'input-minimum',
          'occupancyFormula',
          'inputMinimum',
          'percent',
          values((p) => p.occupancyInputMinimumPercent),
        ),
        row(
          'input-maximum',
          'occupancyFormula',
          'inputMaximum',
          'percent',
          values((p) => p.occupancyInputMaximumPercent),
        ),
      ],
    },
    {
      id: 'occupancy',
      titleKey: 'occupancy',
      rows: indexedRows(
        profiles,
        (p) => p.occupancyTargetBands,
        (index, items) => [
          row(
            `occupancy-${index}-from`,
            'occupancyBand',
            'leadTime',
            'text',
            items.map((value) => (value ? `${value.fromDays}–${value.toDays}` : null)),
          ),
          row(
            `occupancy-${index}-minimum`,
            'occupancyBand',
            'targetMinimum',
            'percent',
            items.map((value) => value?.targetMinimumPercent ?? null),
          ),
          row(
            `occupancy-${index}-maximum`,
            'occupancyBand',
            'targetMaximum',
            'percent',
            items.map((value) => value?.targetMaximumPercent ?? null),
          ),
        ],
      ),
    },
  ];
}
